var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.4329 6.68649C14.1729 6.31315 13.7129 6.09982 13.1863 6.09982H10.4529C10.2729 6.09982 10.1063 6.02649 9.99293 5.89315C9.87293 5.75982 9.82626 5.57315 9.85293 5.37982L10.1929 3.19315C10.3396 2.53982 9.90626 1.80649 9.25293 1.58649C8.64626 1.35982 7.93293 1.66649 7.64626 2.09982L4.83293 6.27982L4.75293 6.41315V12.3065L4.85293 12.4065L6.96626 14.0398C7.24626 14.3198 7.8796 14.4732 8.32626 14.4732H10.9263C11.8196 14.4732 12.7196 13.7998 12.9196 12.9798L14.5596 7.98649C14.7329 7.51315 14.6863 7.05315 14.4329 6.68649Z",
    fill: "#159C4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47301 4.25342H2.78634C1.75301 4.25342 1.33301 4.65342 1.33301 5.64008V12.3468C1.33301 13.3334 1.75301 13.7334 2.78634 13.7334H3.47301C4.50634 13.7334 4.92634 13.3334 4.92634 12.3468V5.64008C4.92634 4.65342 4.50634 4.25342 3.47301 4.25342Z",
    fill: "#159C4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.f7822a34a465cb8e154c686e9293b5a3.svg";
export { ForwardRef as ReactComponent };